import { ReactElement, useRef } from 'react';

import RCMenu from 'rc-menu';

import { MENU_CLASS } from '../../utils/constants';
import * as Styled from './Menu.styles';
import { IMenuProps } from './Menu.types';

const Menu = ({ className = '', mode = 'inline', size = 'medium', ...rest }: IMenuProps): ReactElement => {
  const container = useRef<HTMLDivElement>(null);

  return (
    <Styled.MenuWrapper className={className} size={size} mode={mode} prefixCls={MENU_CLASS} ref={container}>
      <RCMenu
        {...rest}
        prefixCls={MENU_CLASS}
        getPopupContainer={() => container.current as HTMLElement}
        mode={mode}
        inlineIndent={14}
        expandIcon={null}
      />
    </Styled.MenuWrapper>
  );
};

export default Menu;
